import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toIntOrNull3w2d066r9pvwm as toIntOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ReactiveState__getOrNull_impl_1asnfp2wx27g6rqhoxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { FutureElement3o36ukl4wk2br as FutureElement } from '../RView.commonHtml.js.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Companion_getInstance2a03ktg5l3ejl as Companion_getInstance } from '../../models/data.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../reactive/Action.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$Action, $completion) {
  if ($this.ycd_1._v)
    return Unit_instance;
  $this.ycd_1._v = true;
  // Inline function 'com.lightningkite.kiteui.views.valueString' call
  var tmp = $this.zcd_1.tb5_1.zb3_1.ib7_1.value;
  var tmp0_safe_receiver = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : toIntOrNull(tmp0_safe_receiver);
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp_0 = $this.ace_1.gah($this.bce_1._v.q1(tmp1_safe_receiver), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  $this.ycd_1._v = false;
  return Unit_instance;
}
var Select$bind$slambdaClass;
function Select$bind$slambda() {
  if (Select$bind$slambdaClass === VOID) {
    class $ {
      constructor($alreadyHandled, this$0, $edits, $list) {
        this.ycd_1 = $alreadyHandled;
        this.zcd_1 = this$0;
        this.ace_1 = $edits;
        this.bce_1 = $list;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    Select$bind$slambdaClass = $;
  }
  return Select$bind$slambdaClass;
}
function Select$bind$slambda_0($alreadyHandled, this$0, $edits, $list) {
  var i = new (Select$bind$slambda())($alreadyHandled, this$0, $edits, $list);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var SelectClass;
function Select() {
  if (SelectClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.tb5_1.xb3_1 = 'select';
        this.tb5_1.hb4_1.v('editable');
      }
      mcf(edits, data, render) {
        // Inline function 'kotlin.collections.listOf' call
        var list = {_v: emptyList()};
        reactiveScope(this, ($this$reactiveScope) => {
          list._v = $this$reactiveScope.baj(data);
          var v = ReactiveState__getOrNull_impl_1asnfp(edits.qah());
          this.tb5_1.zb9();
          // Inline function 'kotlin.collections.mapIndexed' call
          var this_0 = list._v;
          // Inline function 'kotlin.collections.mapIndexedTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var index = 0;
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var _unary__edvuaz = index;
            index = _unary__edvuaz + 1 | 0;
            var index_0 = checkIndexOverflow(_unary__edvuaz);
            var tmp = this.tb5_1;
            // Inline function 'kotlin.apply' call
            var this_1 = new (FutureElement())();
            this_1.hb4_1.v('kui');
            this_1.xb3_1 = 'option';
            this_1.hb4_1.v('checkResponsive');
            var tmp0 = this_1.zb3_1;
            // Inline function 'com.lightningkite.kiteui.views.valueString' call
            var value = index_0.toString();
            tmp0.ib7_1.value = value;
            this_1.fbu(render(item));
            var tmp0_0 = this_1.zb3_1;
            // Inline function 'com.lightningkite.kiteui.views.selected' call
            var value_0 = equals(item, v);
            tmp0_0.ib7_1.selected = value_0;
            tmp.zbt(this_1);
            destination.v(Unit_instance);
          }
          return Unit_instance;
        });
        var alreadyHandled = {_v: false};
        reactiveScope(this, ($this$reactiveScope) => {
          var newValue = $this$reactiveScope.baj(edits);
          var tmp0_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(data.qah());
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.collections.listOf' call
            tmp = emptyList();
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var list = tmp;
          var tmp_0;
          if (alreadyHandled._v) {
            return Unit_instance;
          }
          alreadyHandled._v = true;
          var index = list.s1(newValue).toString();
          // Inline function 'kotlin.collections.find' call
          var tmp0 = this.tb5_1.oba();
          var tmp$ret$11;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              // Inline function 'com.lightningkite.kiteui.views.valueString' call
              var tmp_1 = element.zb3_1.ib7_1.value;
              if (((!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : null) === index) {
                tmp$ret$11 = element;
                break $l$block;
              }
            }
            tmp$ret$11 = null;
          }
          var tmp1_safe_receiver = tmp$ret$11;
          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.zb3_1;
          if (tmp2_safe_receiver == null)
            null;
          else {
            // Inline function 'com.lightningkite.kiteui.views.selected' call
            tmp2_safe_receiver.ib7_1.selected = true;
          }
          alreadyHandled._v = false;
          return Unit_instance;
        });
        var tmp = Companion_getInstance().rcg_1;
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance_0();
        var tmp_0 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
        var setAction = Action('Set Value', tmp, VOID, VOID, tmp_0, true, Select$bind$slambda_0(alreadyHandled, this, edits, list));
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.tb5_1;
        var tmp0_safe_receiver = this_0.vb3_1;
        var tmp_1;
        if (tmp0_safe_receiver == null) {
          tmp_1 = null;
        } else {
          tmp0_safe_receiver.addEventListener('change', (it) => {
            setAction.xbe(this);
            return Unit_instance;
          });
          tmp_1 = Unit_instance;
        }
        if (tmp_1 == null) {
          // Inline function 'kotlin.run' call
          var tmp_2 = this_0.eb4_1['on' + 'change'];
          var old = (!(tmp_2 == null) ? typeof tmp_2 === 'function' : false) ? tmp_2 : null;
          var tmp_3 = 'on' + 'change';
          this_0.eb4_1[tmp_3] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            setAction.xbe(this);
            return Unit_instance;
          };
        }
      }
      cbs(value) {
        var tmp0 = this.tb5_1.zb3_1;
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var value_0 = !value;
        tmp0.ib7_1.disabled = value_0;
      }
      dbs() {
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var tmp = this.tb5_1.zb3_1.ib7_1.disabled;
        var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null;
        return !(tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs);
      }
      sb9(theme) {
        var p = this.vb5_1;
        var newClass = this.pc().ob3_1.ab2(theme.eb1_1);
        super.sb9(theme);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.tb5_1.oba().m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (p == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            element.hb4_1.w3(p);
          }
          element.hb4_1.v(newClass);
        }
      }
    }
    initMetadataForClass($, 'Select');
    SelectClass = $;
  }
  return SelectClass;
}
//region block: exports
export {
  Select as Select2osqjs95yxuh6,
};
//endregion

//# sourceMappingURL=Select.commonHtml.mjs.map
